import { FC, ReactNode, RefObject } from "react";
import { QrScannerState } from "../../hooks/useQrScanner";
import Button from "../ui/Button";

const CAMERA_TEXT: Record<QrScannerState, string> = {
  idle: "",
  starting: "Duke hapur kamerën…",
  running: "",
  denied: "Kamera është e bllokuar",
  unavailable: "Kamera nuk u hap"
};

type Props = {
  videoRef: RefObject<HTMLVideoElement>;
  state: QrScannerState;
  busy: boolean;
  onRetry: () => void;
  children?: ReactNode;
};

const CameraView: FC<Props> = ({ videoRef, state, busy, onRetry, children }) => (
  <div
    className="relative h-[45vh] max-h-[30rem] min-h-[18rem] w-full overflow-hidden rounded-lg bg-black
      sm:aspect-[4/3] sm:h-auto sm:max-h-none sm:min-h-0"
  >
    <video ref={videoRef} className="h-full w-full object-cover" muted playsInline />
    {children}
    {state !== "running" && (
      <div
        className="pointer-events-none absolute inset-0 z-20 flex flex-col items-center justify-center gap-3
          p-6 text-center text-white"
      >
        <span>{CAMERA_TEXT[state]}</span>
        {(state === "denied" || state === "unavailable") && (
          <Button className="pointer-events-auto h-11" onClick={onRetry}>
            Provo përsëri
          </Button>
        )}
      </div>
    )}
    {busy && (
      <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
        <span className="h-10 w-10 animate-spin rounded-full border-4 border-white border-t-transparent" />
      </div>
    )}
  </div>
);

export default CameraView;
